var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.500001 24.8366 0.500001 16C0.500002 7.16344 7.66344 -2.17128e-06 16.5 -1.39876e-06C25.3366 -6.26248e-07 32.5 7.16344 32.5 16Z",
    fill: "#ED0039"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8771 20.8438C16.6688 21.0521 16.3312 21.0521 16.1229 20.8438L8.65621 13.3771C8.44793 13.1688 8.44793 12.8312 8.65621 12.6229C8.86449 12.4146 9.20218 12.4146 9.41046 12.6229L16.5 19.7124L23.5895 12.6229C23.7978 12.4146 24.1355 12.4146 24.3438 12.6229C24.5521 12.8312 24.5521 13.1688 24.3438 13.3771L16.8771 20.8438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpError);
export default __webpack_public_path__ + "static/media/chevron-up-error.a7a487b97bc694fe3589e7e57f38ecb5.svg";
export { ForwardRef as ReactComponent };